export default __webpack_public_path__ + "static/media/testnet-instructions.9dcb2a6e.gif";